'use strict';

const { BucksBoxClient }   = require('./src/BucksBoxClient');
const { GatewayClient }    = require('./src/http');
const { encrypt, decrypt, checksum } = require('./src/crypto');
const { GATEWAY_ENVIRONMENTS } = require('./src/environments');

// Named module exports for tree-shaking and direct use
const { VendorModule }     = require('./src/modules/VendorModule');
const { WalletModule }     = require('./src/modules/WalletModule');
const { DmtModule }        = require('./src/modules/DmtModule');
const { AepsModule }       = require('./src/modules/AepsModule');
const { UpiModule }        = require('./src/modules/UpiModule');
const { QrModule }         = require('./src/modules/QrModule');
const { CommissionModule } = require('./src/modules/CommissionModule');
const { RegistrationModule } = require('./src/modules/RegistrationModule');
const { OnboardingModule }   = require('./src/modules/OnboardingModule');

// Embeddable UI widgets (browser-only — mount pre-built AEPS/DMT/UPI flows)
const {
  AepsWidget,
  AepsOnboardingWidget,
  DmtWidget,
  DmtOnboardingWidget,
  UpiWidget,
  MerchantSignupWidget,
  MerchantOnboardingWidget,
  Checkout,
  bucksboxHandler,
} = require('./src/ui');

module.exports = {
  // Main entry point
  BucksBoxClient,

  // Low-level building blocks
  GatewayClient,

  // Crypto utilities (useful for server-side verification)
  encrypt,
  decrypt,
  checksum,

  // Named environment -> gatewayUrl lookup (see config.environment on
  // BucksBoxClient/Checkout)
  GATEWAY_ENVIRONMENTS,

  // Module classes (for custom composition)
  VendorModule,
  WalletModule,
  DmtModule,
  AepsModule,
  UpiModule,
  QrModule,
  CommissionModule,
  RegistrationModule,
  OnboardingModule,

  // UI widgets
  AepsWidget,
  AepsOnboardingWidget,
  DmtWidget,
  DmtOnboardingWidget,
  UpiWidget,
  MerchantSignupWidget,
  MerchantOnboardingWidget,

  // Razorpay/Stripe-Checkout-style drop-in wrapper (also exposed as bare
  // window.bucksbox/window.bucksboxHandler globals in the browser bundle —
  // see scripts/build.js)
  Checkout,
  bucksboxHandler,
};

// Bare `bucksbox`/`bucksboxHandler` globals, matching the integration shape
// `new bucksbox(options); buckspay.open(); bucksboxHandler(function (e) {...})`
// — additive to the window.BucksBox.* namespace above, not a replacement.
if (typeof window !== 'undefined') {
  window.bucksbox = Checkout;
  window.bucksboxHandler = bucksboxHandler;
}
